import React from "react";
import { sliderPortrait } from "../../data/films";
import { AI_FILTER, defeatedTells } from "../../data/notell";
export function DefeatedTells() {
  return <div data-id="element-243" data-mp="yfh00fjyye5a">
      <h3 className="font-serif text-[26px] leading-none tracking-[-0.01em] text-white md:text-[32px]" data-id="element-244" data-mp="12f7xf2403sis">
        The tells. <em className="italic text-signal" data-id="element-245" data-mp="17e2i69lj3r5j">Defeated.</em>
      </h3>
      <ul className="mt-8 grid grid-cols-3 gap-x-2.5 gap-y-5 sm:grid-cols-6 sm:gap-x-3 lg:gap-x-4" data-id="element-246" data-mp="17c81x8l7cn7s">
        {defeatedTells.map(tell => <li key={tell.word} data-id="element-247" data-mp="eovhb3ylqph4">
            <div className="relative aspect-square overflow-hidden border border-hairline bg-card" data-id="element-248" data-mp="eq6jizcefp64">
              <div className="absolute inset-0" role="img" aria-label={`Close-up of ${tell.word.toLowerCase()} on the typical AI version`} style={{
            backgroundImage: `url(${sliderPortrait.src})`,
            backgroundSize: `${tell.zoom}% auto`,
            backgroundPosition: `${tell.x}% ${tell.y}%`,
            filter: AI_FILTER
          }} data-id="element-249" data-mp="jn6t3k8gja1z" />
              <div className="absolute inset-0 bg-black/35" aria-hidden="true" data-id="element-250" data-mp="2bd23usqi2cj9" />
              <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-id="element-251" data-mp="26mbyhfi2q9ok">
                <line x1="6" y1="94" x2="94" y2="6" stroke="#FF4950" strokeWidth="2" vectorEffect="non-scaling-stroke" data-id="element-252" data-mp="21mfq742cfw37" />
              </svg>
              <span className="absolute left-2 top-2 bg-signal px-1.5 py-0.5 font-mono text-[9px] tracking-[0.14em] text-ink" data-id="element-253" data-mp="1wm1ixo8kgq68">
                DEFEATED
              </span>
            </div>
            <p className="mt-2 font-serif text-[14px] leading-tight text-foot line-through decoration-signal decoration-2 sm:text-[16px] lg:text-[20px] md:mt-3" data-id="element-254" data-mp="1nptx06dfavf4">
              {tell.word}
            </p>
          </li>)}
      </ul>
    </div>;
}